export default __webpack_public_path__ + "static/media/PersImg24.117c858f.jpg";